export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";